import { BREAKPOINTS } from '@fire/_mediaQueries';

export const checkIsMobile = width => width <= BREAKPOINTS.xs;

export const isCrawler = userAgent =>
  /bot|googlebot|crawler|spider|robot|crawling/i.test(userAgent);
